import React, { useEffect, useState } from "react";
// import { useFormik } from "formik";
import { Formik, Form, Field } from "formik";

import Swal from "sweetalert2";
import * as Yup from "yup";
import { Container, Label, Input } from "reactstrap";
import { useNavigate } from "react-router-dom";
// import { Loading } from "../../share/loading";
import "../../share/form.css";
// import { NumberWithCommas } from "../../share/NumberWithCommas";

export function SupportAdminConditionComponent() {
  // const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("userData"));
  //   console.log(user);
  // let supportId = searchParams.get("req");

  // let userApprove = user.
  // const [loading, setLoading] = useState(false);
  // const [remarkValue, setRemarkValue] = useState("");
  const [foundValue, setFoundValue] = useState(false);

  // const [remarkPromotionValue, setRemarkPromotionValue] = useState("");
  // const [data, setData] = useState([]);

  const [Condition, setCondition] = useState([]);
  const [Condition1, setCondition1] = useState([]);
  const [Condition2, setCondition2] = useState([]);
  const [ConditionDate, setConditionDate] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const ToggleButtondisabled = () => setDisabled(!disabled);

  //   useEffect(() => {
  //     getCheckSupport();
  //   }, []);

  useEffect(() => {
    async function GetProvince() {
      // setLoading(true);
      try {
        const responseCondition = await fetch("/api/Borrow/getCondition");
        const data = await responseCondition.json();
        if (data !== null) {
          setFoundValue(true)
        }
        setCondition(data.dataenum);
      } catch (e) {
        console.log("err => " + e);
      } finally {
        // setLoading(false);
      }
    }
    GetProvince();
  }, []);


  const formInitialValues = {
    supportConditionId: Condition1[0]?.supportConditionId ?? "",
    Condition1Annouce: Condition1[0]?.condition1 ?? "",
    Condition2Annouce: Condition2[0]?.condition2 ?? "",
    Condition2DateAnnouce: ConditionDate[0]?.conditionDate ?? "",
    Updateby: user.fullName,
    Createby: user.fullName,
  };

  const validateSchema = Yup.object().shape({});

  const onSubmit = async (values) => {
    // console.log("Values", values);
    let postData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      postData.append(key, value);
    });
    try {
      let res = await fetch("api/Support/SaveConditionChange", {
        method: "POST",
        // headers: { "Content-type": "application/json" },
        body: postData,
      });
      // console.log("values5", values);
      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then((result) => {
          navigate(`/supporting/`);
        });
      }
      else {
        Swal.fire({
          icon: "warning",
          title: "บันทึกข้อมูลไม่สำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        })
      }
    } catch (e) {
      console.log(e);
    }

  };

  return (
    <Container className="d-flex flex-column justify-content-center align-items-center">
      <p
        className="text-center py-2 text-white"
        style={{ backgroundColor: "#0A66C2", width: "100%", maxWidth: "850px" }}
      >
        ข้อมูลรายละเอียดเงื่อนไขตามประกาศ
      </p>
      {/* รายละเอียดย่อย */}
      <div className="form-border">
        <Formik
          initialValues={formInitialValues}
          validationSchema={validateSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ values, handleChange, handleBlur, setFieldValue, setValues, resetForm, errors, touched }) => {
            async function GetCondition1(e) {
              let postData = new FormData();
              postData.append("supportConditionId", e.target.value);
              try {
                const responseCondition1 = await fetch(
                  "/api/Borrow/getCondition1",
                  {
                    method: "POST",
                    body: postData,
                  }
                );
                const Condition1 = await responseCondition1.json();
                setCondition1(Condition1.dataenum);
              } catch (err) {
                console.log("err =>" + err);
              }
            }

            // ดึง master data ตำบล ที่อยู่ปัจจุบันที่ติดต่อได้
            async function GetCondition2(e) {
              let postData = new FormData();
              postData.append("supportConditionId", e.target.value);

              try {
                let responseCondition2 = await fetch("/api/Borrow/getCondition2", {
                  method: "POST",
                  body: postData,
                });
                const Condition2 = await responseCondition2.json();
                setCondition2(Condition2.dataenum);
              } catch (err) {
                console.log("err =>" + err);
              }
            }
            async function GetConditionDate(e) {
              let postData = new FormData();
              postData.append("supportConditionId", e.target.value);
              try {
                let responseConditionDate = await fetch(
                  "/api/Borrow/getConditionDate",
                  {
                    method: "POST",
                    body: postData,
                  }
                );
                const ConditionDate = await responseConditionDate.json();
                setConditionDate(ConditionDate.dataenum);
              } catch (err) {
                console.log("err =>" + err);
              }
            }

            return (
              <div className="d-flex flex-column">
                <div className="px-5 mt-5 d-flex justify-content-evenly">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <span className="type-register w-25">หัวข้อประกาศ</span>
                    <Field name={`supportConditionId`}>
                      {({ field, form, meta }) => (
                        <Input
                          disabled={values.changePlace === false}
                          type="select"
                          className="rounded-pill text-center input-color w-75"
                          {...field}
                          onChange={(e) => {
                            handleChange(e);
                            GetCondition1(e);
                            GetCondition2(e);
                            GetConditionDate(e);
                          }}
                        >
                          <option defaultValue={"กรุณาเลือกหัวข้อประกาศ"}>
                            กรุณาเลือกหัวข้อประกาศ
                          </option>
                          {Condition.map((p) => (
                            <option
                              key={p.supportConditionId}
                              value={String(p.supportConditionId)}
                            >
                              {p.announceDetail}
                            </option>
                          ))}
                        </Input>
                      )}
                    </Field>
                  </div>
                </div>
                <div className="px-5 mt-5 d-flex justify-content-evenly">
                  <div className="d-flex justify-content-evenly align-items-center w-100">
                    {Condition1[0]?.supportConditionId === 1 ? (
                      <div className="d-flex flex-column justify-content-evenly align-items-center w-100">
                        <div className="d-flex justify-conetent-center align-items-center w-100">
                          <Label>สิทธิขอรับเงินช่วยเหลือหรืออุดหนุน :</Label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mt-3">
                          <span className=" type-register  w-25">
                            ตั้งแต่ 100 คนขึ้นไป ให้
                          </span>
                          <Field name={`Condition1Annouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className={meta.touched && meta.error ?
                                  "w-25 input-error rounded-pill text-center input-color" :
                                  "w-25 rounded-pill text-center input-color"}
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);
                                }}

                                onBlur={handleBlur}


                              />
                            )}
                          </Field>

                          <span className="type-register w-25">บาท</span>
                        </div>

                        <div className="d-flex justify-content-between align-items-center w-100 mt-5">
                          <span className="type-register w-25">
                            ส่วนที่เกิน 100 คน ให้
                          </span>
                          <Field name={`Condition2Annouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className="w-25 rounded-pill text-center input-color"
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);

                                }}
                                onBlur={handleBlur}

                              ></Input>
                            )}
                          </Field>
                          <span className="type-register w-25">บาท ต่อคน</span>
                        </div>

                        <div className="d-flex justify-conetent-center align-items-center w-100 mt-3">
                          <Label>กำหนดเวลาการยื่นคำขอ :</Label>
                        </div>
                        <div className="d-flex  justify-content-between align-items-center w-100 mt-2">
                          <span className="py-1 mx-1 type-register w-25">
                            ภายใน
                          </span>
                          <Field name={`Condition2DateAnnouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className="w-25 rounded-pill text-center input-color"
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);
                                }}

                              ></Input>
                            )}
                          </Field>
                          <span className="type-register w-25">
                            วันนับแต่วันที่มีสิทธิขอรับเงินช่วยเหลือหรืออุดหนุน
                          </span>
                        </div>
                      </div>
                    ) : null}

                    {Condition1[0]?.supportConditionId === 2 ? (
                      <div className="d-flex flex-column justify-content-evenly align-items-center w-100">
                        <div className="d-flex justify-conetent-center align-items-center w-100">
                          <Label>สิทธิขอรับเงินช่วยเหลือหรืออุดหนุน :</Label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mt-3">

                          <Field name={`Condition1Annouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className={meta.touched && meta.error ?
                                  "w-100 input-error rounded-pill text-center input-color" :
                                  "w-100 rounded-pill text-center input-color"}
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);

                                }}

                                onBlur={handleBlur}


                              />
                            )}
                          </Field>


                        </div>



                        <div className="d-flex justify-conetent-center align-items-center w-100 mt-3">
                          <Label>กำหนดเวลาการยื่นคำขอ :</Label>
                        </div>
                        <div className="d-flex  justify-content-between align-items-center w-100 mt-2">
                          <span className="py-1 mx-1 type-register w-25">
                            ภายใน
                          </span>
                          <Field name={`Condition2DateAnnouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className="w-25 rounded-pill text-center input-color"
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);
                                }}

                              ></Input>
                            )}
                          </Field>
                          <span className="type-register w-25">
                            วันนับแต่วันที่มีสิทธิขอรับเงินช่วยเหลือหรืออุดหนุน
                          </span>
                        </div>
                      </div>
                    ) : null}

                    {Condition1[0]?.supportConditionId === 3 ? (
                      <div className="d-flex flex-column justify-content-evenly align-items-center w-100">
                        <div className="d-flex justify-conetent-center align-items-center w-100">
                          <Label>สิทธิขอรับเงินช่วยเหลือหรืออุดหนุน :</Label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mt-3">

                          <Field name={`Condition1Annouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className={meta.touched && meta.error ?
                                  "w-100 input-error rounded-pill text-center input-color" :
                                  "w-100 rounded-pill text-center input-color"}
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);

                                }}

                                onBlur={handleBlur}


                              />
                            )}
                          </Field>
                        </div>

                        <div className="d-flex justify-conetent-center align-items-center w-100 mt-3">
                          <Label>กำหนดเวลาการยื่นคำขอ :</Label>
                        </div>
                        <div className="d-flex  justify-content-between align-items-center w-100 mt-2">
                          <span className="py-1 mx-1 type-register w-25">
                            ภายใน
                          </span>
                          <Field name={`Condition2DateAnnouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className="w-25 rounded-pill text-center input-color"
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);
                                }}

                              ></Input>
                            )}
                          </Field>
                          <span className="type-register w-25">
                            วันนับแต่วันที่มีสิทธิขอรับเงินช่วยเหลือหรืออุดหนุน
                          </span>
                        </div>
                      </div>
                    ) : null}

                    {Condition1[0]?.supportConditionId === 4 ? (
                      <div className="d-flex flex-column justify-content-evenly align-items-center w-100">
                        <div className="d-flex justify-conetent-center align-items-center w-100">
                          <Label>สิทธิขอรับเงินช่วยเหลือหรืออุดหนุน :</Label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mt-3">
                          <span className="py-1 mx-1 type-register w-25">
                            ร้อยละ
                          </span>
                          <Field name={`Condition1Annouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className={meta.touched && meta.error ?
                                  "w-25 input-error rounded-pill text-center input-color" :
                                  "w-25 rounded-pill text-center input-color"}
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);

                                }}

                                onBlur={handleBlur}


                              />
                            )}
                          </Field>
                          <span className="py-1 mx-1 type-register w-25">
                            ของจำนวนเงินที่ส่งเงินสมทบเข้ากองทุน
                          </span>
                        </div>

                        <div className="d-flex justify-conetent-center align-items-center w-100 mt-3">
                          <Label>กำหนดเวลาการยื่นคำขอ :</Label>
                        </div>
                        <div className="d-flex  justify-content-between align-items-center w-100 mt-2">
                          <span className="py-1 mx-1 type-register w-25">
                            ภายใน
                          </span>
                          <Field name={`Condition2DateAnnouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className="w-25 rounded-pill text-center input-color"
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);
                                }}

                              ></Input>
                            )}
                          </Field>
                          <span className="type-register w-25">
                            วันนับแต่วันที่มีสิทธิขอรับเงินช่วยเหลือหรืออุดหนุน
                          </span>
                        </div>
                      </div>
                    ) : null}


                    {Condition1[0]?.supportConditionId === 5 ? (
                      <div className="d-flex flex-column justify-content-evenly align-items-center w-100">
                        <div className="d-flex justify-conetent-center align-items-center w-100">
                          <Label>สิทธิขอรับเงินช่วยเหลือหรืออุดหนุน :</Label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mt-3">

                          <Field name={`Condition1Annouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className={meta.touched && meta.error ?
                                  "w-75 input-error rounded-pill text-center input-color" :
                                  "w-75 rounded-pill text-center input-color"}
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);

                                }}

                                onBlur={handleBlur}


                              />
                            )}
                          </Field>
                          <span className="py-1 mx-1 type-register w-25">
                            บาท ต่อลูกจ้าง 1 คน
                          </span>
                        </div>

                        <div className="d-flex justify-conetent-center align-items-center w-100 mt-3">
                          <Label>กำหนดเวลาการยื่นคำขอ :</Label>
                        </div>
                        <div className="d-flex  justify-content-between align-items-center w-100 mt-2">
                          <span className="py-1 mx-1 type-register w-25">
                            ภายใน
                          </span>
                          <Field name={`Condition2DateAnnouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className="w-25 rounded-pill text-center input-color"
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);
                                }}

                              ></Input>
                            )}
                          </Field>
                          <span className="type-register w-25">
                            วันนับแต่วันที่มีสิทธิขอรับเงินช่วยเหลือหรืออุดหนุน
                          </span>
                        </div>
                      </div>
                    ) : null}

                    {Condition1[0]?.supportConditionId === 6 ? (
                      <div className="d-flex flex-column justify-content-evenly align-items-center w-100">
                        <div className="d-flex justify-conetent-center align-items-center w-100">
                          <Label>สิทธิขอรับเงินช่วยเหลือหรืออุดหนุน :</Label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mt-3">
                          <span className="type-register w-25">
                            สาขาระดับละ
                          </span>
                          <Field name={`Condition1Annouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className={meta.touched && meta.error ?
                                  "w-25 input-error rounded-pill text-center input-color" :
                                  "w-25 rounded-pill text-center input-color"}
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);

                                }}

                                onBlur={handleBlur}


                              />
                            )}
                          </Field>
                          <span className="py-1 mx-1 type-register w-25">
                            บาท
                          </span>
                        </div>

                        <div className="d-flex justify-conetent-center align-items-center w-100 mt-3">
                          <Label>กำหนดเวลาการยื่นคำขอ :</Label>
                        </div>
                        <div className="d-flex  justify-content-between align-items-center w-100 mt-2">
                          <span className="py-1 mx-1 type-register w-25">
                            ภายใน
                          </span>
                          <Field name={`Condition2DateAnnouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className="w-25 rounded-pill text-center input-color"
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);
                                }}

                              ></Input>
                            )}
                          </Field>
                          <span className="type-register w-25">
                            วันนับแต่วันที่มีสิทธิขอรับเงินช่วยเหลือหรืออุดหนุน
                          </span>
                        </div>
                      </div>
                    ) : null}

                    {Condition1[0]?.supportConditionId === 7 ? (
                      <div className="d-flex flex-column justify-content-evenly align-items-center w-100">
                        <div className="d-flex justify-conetent-center align-items-center w-100">
                          <Label>สิทธิขอรับเงินช่วยเหลือหรืออุดหนุน :</Label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mt-3">

                          <Field name={`Condition1Annouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className={meta.touched && meta.error ?
                                  "w-75 input-error rounded-pill text-center input-color" :
                                  "w-75 rounded-pill text-center input-color"}
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);

                                }}

                                onBlur={handleBlur}


                              />
                            )}
                          </Field>
                          <span className="py-1 mx-1 type-register w-25">
                            บาท ต่อลูกจ้าง 1 คน
                          </span>
                        </div>

                        <div className="d-flex justify-conetent-center align-items-center w-100 mt-3">
                          <Label>กำหนดเวลาการยื่นคำขอ :</Label>
                        </div>
                        <div className="d-flex  justify-content-between align-items-center w-100 mt-2">
                          <span className="py-1 mx-1 type-register w-25">
                            ภายใน
                          </span>
                          <Field name={`Condition2DateAnnouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className="w-25 rounded-pill text-center input-color"
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);
                                }}

                              ></Input>
                            )}
                          </Field>
                          <span className="type-register w-25">
                            วันนับแต่วันที่มีสิทธิขอรับเงินช่วยเหลือหรืออุดหนุน
                          </span>
                        </div>
                      </div>
                    ) : null}

                    {Condition1[0]?.supportConditionId === 8 ? (
                      <div className="d-flex flex-column justify-content-evenly align-items-center w-100">
                        <div className="d-flex justify-conetent-center align-items-center w-100">
                          <Label>สิทธิขอรับเงินช่วยเหลือหรืออุดหนุน :</Label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mt-3">
                          <span className="py-1 mx-1 type-register w-25">
                            เท่าที่จริงจ่ายไม่เกินปีละ
                          </span>
                          <Field name={`Condition1Annouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className={meta.touched && meta.error ?
                                  "w-25 input-error rounded-pill text-center input-color" :
                                  "w-25 rounded-pill text-center input-color"}
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);

                                }}

                                onBlur={handleBlur}


                              />
                            )}
                          </Field>
                          <span className="py-1 mx-1 type-register w-25">
                            บาท
                          </span>
                        </div>

                        <div className="d-flex justify-conetent-center align-items-center w-100 mt-3">
                          <Label>กำหนดเวลาการยื่นคำขอ :</Label>
                        </div>
                        <div className="d-flex  justify-content-between align-items-center w-100 mt-2">
                          <span className="py-1 mx-1 type-register w-25">
                            ภายใน
                          </span>
                          <Field name={`Condition2DateAnnouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className="w-25 rounded-pill text-center input-color"
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);
                                }}

                              ></Input>
                            )}
                          </Field>
                          <span className="type-register w-25">
                            วันนับแต่วันที่มีสิทธิขอรับเงินช่วยเหลือหรืออุดหนุน
                          </span>
                        </div>
                      </div>
                    ) : null}

                    {Condition1[0]?.supportConditionId === 9 ? (
                      <div className="d-flex flex-column justify-content-evenly align-items-center w-100">
                        <div className="d-flex justify-conetent-center align-items-center w-100">
                          <Label>สิทธิขอรับเงินช่วยเหลือหรืออุดหนุน :</Label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mt-3">

                          <Field name={`Condition1Annouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className={meta.touched && meta.error ?
                                  "w-100 input-error rounded-pill text-center input-color" :
                                  "w-100 rounded-pill text-center input-color"}
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);

                                }}
                                onBlur={handleBlur}

                              />
                            )}
                          </Field>

                        </div>

                        <div className="d-flex justify-conetent-center align-items-center w-100 mt-3">
                          <Label>กำหนดเวลาการยื่นคำขอ :</Label>
                        </div>
                        <div className="d-flex  justify-content-between align-items-center w-100 mt-2">
                          <span className="py-1 mx-1 type-register w-25">
                            ภายใน
                          </span>
                          <Field name={`Condition2DateAnnouce`}>
                            {({ field, form, meta }) => (
                              <Input
                                disabled={disabled}
                                type="text"
                                className="w-25 rounded-pill text-center input-color"
                                {...field}
                                onChange={(e) => {
                                  handleChange(e);
                                }}

                              ></Input>
                            )}
                          </Field>
                          <span className="type-register w-25">
                            วันนับแต่วันที่มีสิทธิขอรับเงินช่วยเหลือหรืออุดหนุน
                          </span>
                        </div>
                      </div>
                    ) : null}


                  </div>
                </div>

                <div className="d-flex justify-content-evenly text-center w-100">
                  <Form className="d-flex justify-content-evenly text-center w-100">
                    <button className="btn-green rounded-pill w-25 my-5" type="submit">
                      บันทึก
                    </button>
                    <button
                      className="btn-yellow rounded-pill w-25 my-5"
                      onClick={ToggleButtondisabled}
                      type="button"
                    >
                      แก้ไข
                    </button>
                    <button className="btn-red rounded-pill w-25 my-5"
                      type="button">
                      ยกเลิก
                    </button>
                  </Form>
                </div>
              </div>
            );
          }}
        </Formik>
      </div>

      <div class="boxes-tn">
        <div></div> <div></div>
        <div></div> <div></div>
        <div></div> <div></div>
        <div></div> <div></div>
        <div></div>
      </div>

    </Container>
  );
}